// removed by extract-text-webpack-plugin
module.exports = {"goBack_link":"GoBack-m__goBack_link___3DN2h","goBackLink":"GoBack-m__goBack_link___3DN2h","goBack_icon":"GoBack-m__goBack_icon___1cYrK","goBackIcon":"GoBack-m__goBack_icon___1cYrK","goBack_text":"GoBack-m__goBack_text___2IPWi","goBackText":"GoBack-m__goBack_text___2IPWi"};


//////////////////
// WEBPACK FOOTER
// ./components/goBack/GoBack.m.sass
// module id = DM7d
// module chunks = 0